import { render, staticRenderFns } from "./ShareLinkPopup.vue?vue&type=template&id=b63ab1be&scoped=true&lang=html"
import script from "./ShareLinkPopup.vue?vue&type=script&lang=js"
export * from "./ShareLinkPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63ab1be",
  null
  
)

export default component.exports